import {
  Box,
  Heading,
  HStack,
  Icon,
  Label,
  ListOptionType,
  MultiSelectField,
  SubmitButton,
  Text,
  VStack,
} from '@medely/ui-kit';
import { useFormContext } from '@medely/ui-kit/react-hook-form';
import { FixedFooterLayout } from '@mp/components/FixedFooterLayout';
import React from 'react';
import { UnsavedChangesDialog } from './UnsavedChangesDialog';
import useDialog from '@mp/hooks/useDialog';
import { hasChangesOnForm } from '../../utils';

type SpecialtiesFormProps = {
  positionName: string | null | undefined;
  onBackClick: (params: undefined) => void;
  isSpecialtiesLoading: boolean;
  options: ListOptionType[] | undefined;
  preSelectedSpecialties: number[] | undefined;
};

export const SpecialtiesForm = ({
  onBackClick,
  positionName,
  isSpecialtiesLoading,
  options,
  preSelectedSpecialties,
}: SpecialtiesFormProps) => {
  const { open, openDialog, closeDialog } = useDialog();
  const { watch } = useFormContext();

  const newSelectedSpecialties = watch('specialty_ids');

  const handleBackClick = () => {
    const hasUnsavedChanges = !hasChangesOnForm({
      preSelectedSpecialties,
      selectedSpecialties: newSelectedSpecialties,
    }).hasNoPayload;
    if (hasUnsavedChanges) {
      return openDialog();
    }
    onBackClick(undefined);
  };

  return (
    <>
      <FixedFooterLayout
        height="100%"
        title={
          <>
            <Box onClick={() => handleBackClick()} testId="specialties-view-back-button">
              <HStack>
                <Icon
                  name="chevron-left"
                  color="state.teal.primary"
                  variant="custom"
                  iconSize="10px"
                />
                <Label size="m" color="state.teal.primary">
                  Positions and specialties
                </Label>
              </HStack>
            </Box>
            <Heading size="m" color="text.primary" testId="specialties-view-tile">
              {positionName}
            </Heading>
            <Box pt={1}>
              <Text size="m" color="text.secondary" testId="specialties-view-info">
                Add any relevant specialties for this position. If any specialties have lapsed,
                remove them to ensure more accurate shift matches.
              </Text>
            </Box>
          </>
        }
        footerContent={
          <SubmitButton
            fullWidth
            disabled={isSpecialtiesLoading}
            loading={isSpecialtiesLoading}
            testId="specialties-view-update-button"
          >
            Update
          </SubmitButton>
        }
      >
        <VStack gap={2} pt={15} testId="specialties-view-options">
          {!!options && (
            <MultiSelectField
              variant="list"
              options={options}
              label="Selected Positions"
              name="specialty_ids"
            />
          )}
        </VStack>
      </FixedFooterLayout>
      <UnsavedChangesDialog onClose={closeDialog} open={open} onDiscardChangesClick={onBackClick} />
    </>
  );
};
